import NextLink from "next/link";
import { Chakra } from "@airhelp/react-ui-components";
import { LinkIcon } from "styles/icons";

interface ListItemTypes {
  url: string;
  anchorText: string;
}

interface LinkBoxProps {
  linkItems: ListItemTypes[];
}

const { Link, Text, List, ListItem } = Chakra;

const LinkBox = ({ linkItems }: LinkBoxProps) => (
  <List>
    {linkItems.map(({ url, anchorText }) => (
      <ListItem key={url} my={2}>
        <NextLink href={url} passHref>
          <Link color="primary.500" fontSize="lg" d="flex" alignItems="center">
            <LinkIcon />
            <Text ml={4}>{anchorText}</Text>
          </Link>
        </NextLink>
      </ListItem>
    ))}
  </List>
);

export default LinkBox;
